<script setup lang="ts">

  const { t } = useI18n()

  const props = defineProps<{
    checkinHour: string
    packHour: number
    checkinDate: string
    extraHours: number
  }>()

  const checkOutDate = calculateCheckOut(props.checkinHour || '', props.packHour || 0, props.extraHours || 0, props.checkinDate || '')

</script>

<template>
  <div class="flex justify-between items-center gap-8 mb-6">
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1 mb-1">
        <UIcon name="i-lucide-log-in" class="text-gray-500"/>
        <p class="text-xs sm:text-sm font-medium text-gray-500 text-nowrap">{{ t('checkout.summary.checkIn') }}</p>
      </div>

      <p class="text-sm sm:text-base font-semibold">{{ formatTime(checkinHour || '') }}</p>
      <p class="text-xs sm:text-sm text-toned whitespace-nowrap">{{ checkinDate || '' }}</p>
    </div>

    <USeparator
      type="dotted"
      size="md"
    >
      <template #default>
        <div class="flex items-center gap-1">
          <span :class="extraHours > 0 ? 'line-through text-gray-500 text-sm' : 'text-gray-500'">{{ packHour || 0 }}h</span>
          <span v-if="extraHours > 0" class="text-success text-sm sm:text-base">{{ packHour + extraHours || 0 }}h</span>
        </div>
      </template>
    </USeparator>

    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1 mb-1">
        <UIcon name="i-lucide-log-out" class="text-gray-500"/>
        <p class="text-xs sm:text-sm font-medium text-gray-500 text-nowrap">{{ t('checkout.summary.checkOut') }}</p>
      </div>

      <p class="text-sm sm:text-base font-semibold">{{ checkOutDate.hour || '' }}</p>
      <p class="text-xs sm:text-sm text-toned whitespace-nowrap">{{ checkOutDate.day || '' }}</p>
    </div>
  </div>
</template>